import { OperationTypeEnum } from "@gtpl/shared-models/common-models";

export const OPERATION_FIELDS: any = {
  [OperationTypeEnum.OPENING]: [
    // { name: 'variant', label: 'Variant', type: 'select', required: true },
    { name: 'quality', label: 'Quality', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.CARDING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.DRAWING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.COMBING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.PASSAGE]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.DRESSING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.PICKING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    // { name: 'product', label: 'Product', type: 'input', required: true },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.SPREADER]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    // { name: 'product', label: 'Product', type: 'input', required: true },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.SIMPLEX]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.RING_FRAME]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'countType', label: 'Count Type', type: 'select', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.DOUBLING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'countType', label: 'Count Type', type: 'select', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.AUTO_CONER]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'countType', label: 'Count Type', type: 'select', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.GASING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'countType', label: 'Count Type', type: 'select', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.CONEWINDING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'countType', label: 'Count Type', type: 'select', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.REELING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'countType', label: 'Count Type', type: 'select', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.BLOWROOM]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

    [OperationTypeEnum.CARDING_C1]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.FLAT_CARDING]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.OPEN_END]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'countType', label: 'Count Type', type: 'select', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.A1]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

    [OperationTypeEnum.B2]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

    [OperationTypeEnum.C3]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ],

  [OperationTypeEnum.SET_FRAME]: [
    { name: 'lotName', label: 'Lot Name', type: 'input', required: false },
    { name: 'quantity', label: 'Quantity', type: 'number', required: true },
    { name: 'remarks', label: 'Remarks', type: 'textarea', required: false }
  ]

};

export const OUTPUT_OPERATION_FIELDS: any = {
  [OperationTypeEnum.SET_FRAME]: [
     { name: 'countType', label: 'Count Type', type: 'enum', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
  ],
  [OperationTypeEnum.SIMPLEX]: [
     { name: 'countType', label: 'Count Type', type: 'enum', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
  ],
  [OperationTypeEnum.RING_FRAME]: [
     { name: 'countType', label: 'Count Type', type: 'enum', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
  ],
  [OperationTypeEnum.DOUBLING]: [
     { name: 'countType', label: 'Count Type', type: 'enum', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
  ],[OperationTypeEnum.AUTO_CONER]: [
     { name: 'countType', label: 'Count Type', type: 'enum', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
  ],[OperationTypeEnum.GASING]: [
     { name: 'countType', label: 'Count Type', type: 'enum', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
  ],[OperationTypeEnum.CONEWINDING]: [
     { name: 'countType', label: 'Count Type', type: 'enum', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
  ],[OperationTypeEnum.REELING]: [
     { name: 'countType', label: 'Count Type', type: 'enum', required: true },
    { name: 'count', label: 'Count', type: 'select', required: true },
  ],
}